// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createActionsHook } from '@atlassian/react-sweet-state';
import { DeleteIssueModalActions, type Actions } from './actions.tsx';
import { initialState } from './constants.tsx';
import type { State } from './types.tsx';

export const DeleteIssueModalStore = createStore<State, Actions>({
	initialState,
	actions: DeleteIssueModalActions,
	name: 'DeleteIssueModalStore',
});

export const useDeleteIssueModalActions = createActionsHook<State, Actions>(DeleteIssueModalStore);
